import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPreference from './preference.reducer';

export const selectPreferenceState = createFeatureSelector<fromPreference.State>(fromPreference.preferenceFeatureKey);

export const selectPreferences = createSelector(selectPreferenceState, (state) => state.preferences);

export const selectIsComplete = createSelector(selectPreferenceState, (state) => state.isComplete);

export const selectIsLoading = createSelector(selectPreferenceState, (state) => state.isLoading);

// Waiting to start getting current user
export const selectIsWaiting = createSelector(
  selectIsComplete,
  selectIsLoading,
  (isComplete, isLoading) => !isComplete && !isLoading
);
